module.exports = __webpack_public_path__ + "static/media/bookingsIcon.77e6abc9.svg";